import * as types from '../mutation-types'

const moduleItens = {
	state: {
        itens: {},
		marcas: {},
		grupos: {},
		subgrupos: {}
    },
	getters: {
        itens: state => { return state.itens },
		marcas: state => { return state.marcas },
		grupos: state => { return state.grupos },
		subgrupos: state => { return state.subgrupos },
    },
	mutations: {
		[types.ADD_ITENS](state, itens) { state.itens = itens },
		[types.ADD_MARCAS](state, marcas) { state.marcas = marcas },
		[types.ADD_GRUPOS](state, grupos) { state.grupos = grupos },
		[types.ADD_SUBGRUPOS](state, subgrupos) { state.subgrupos = subgrupos },
    },
	actions: {
        addItens({ commit }, itens){
			commit(types.ADD_ITENS, itens)
		},
        addMarcas({ commit }, marcas) {
			commit(types.ADD_MARCAS, marcas)
		},
		addGrupos({ commit }, grupos) {
			commit(types.ADD_GRUPOS, grupos)
		},
		addSubgrupos({ commit }, subgrupos) {
			commit(types.ADD_SUBGRUPOS, subgrupos)
		},
    }
}

export default moduleItens